import { IOptions } from './../../../../models/optionsets.interface';
import { Component, OnInit, Output, EventEmitter, Input, NgZone, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';

import { Subscription, Subject } from 'rxjs';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import _moment from 'moment';
import { IProgramCycle } from './../../../../models/programcycle.interface';
import { IDwellingInput } from '../../../../models/dwellingInput.interface';
import { IDwellingReturned } from './../../../../models/dwellingInput.interface';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppLoadService, HelpApiService, IHelp } from '@ebb-v2/ebb-integration';

declare const google: any;

const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY'
  },
  display: {
    dateInput: 'YYYY',
    yearLabel: 'YYYY'
  }
};

@Component({
    selector: 'ebb-start',
    templateUrl: './start.component.html',
    styleUrls: ['./start.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    standalone: false
})
export class StartComponent implements OnInit {
  public dwellingInput: FormGroup;
  @Input() programName: string;
  @Input() program: IProgramCycle;
  @Input() dwelling$: Subject<IDwellingReturned>;
  @Output() nextSection: EventEmitter<number> = new EventEmitter<number>();
  @Output() isFormInvalid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() emitDwelling: EventEmitter<IDwellingInput | IDwellingReturned> = new EventEmitter<IDwellingInput | IDwellingReturned>();
 
  public acceptedZipCodes: string[];
  public displayDate: FormControl = new FormControl(moment());
  public address$: Subscription;

  public listResults: any[] = [];
  public yearBuiltArray: string[] = [];
  public numberOfUnitsArray: string[] = [];
  public listHelp: IHelp[] = [];
  public _policies: IOptions[];
  public _beforestreetnumber:number;
  public _afterstreetnumber:number;
  public programTypeCodeOptionSet: string;
  drawerOpen = false;
  drawerContent: SafeHtml = '';
  yearBuildContent: SafeHtml = '';
  numberOfUnitsContent: SafeHtml = '';
  ownerAssociationContent: SafeHtml = '';
  squareFootageContent: SafeHtml = '';
  public addressQuestion ="What is the property address for this home?"
  @Input() set policies(value: IOptions[]) {
    this._policies = value;
    this.enablePiEntry(true);
  }

  public _dwellingNextInProcess = false;
  @Input() set dwellingNextInProcessComplete(value: boolean) {
    this._dwellingNextInProcess = !value;
  }

  @ViewChild('address_Street') address_Street: ElementRef;
  @ViewChild('address_Street_Line2') address_Street_Line2: ElementRef;
  @ViewChild('address_City') address_City: ElementRef;
  @ViewChild('address_State') address_State: ElementRef;
  @ViewChild('address_Zip') address_Zip: ElementRef;

  constructor(
    private _fb: FormBuilder,
    public zone: NgZone,
    private readonly apiHelp: HelpApiService,
    public sanitizer: DomSanitizer,
    private appLoadService: AppLoadService
  ) { }

  public ngOnInit(): void {

    this.loadHelpText();
    
    this.acceptedZipCodes = this.program.zipCodesAccepted.split(',').map(zip => zip.trim());
    this.constructYearBuiltArray(this.program);
    this.constructNumberOfUnitsArray(this.program);

    this.dwellingInput = this._fb.group({
      address_Street: ['', [Validators.required, Validators.maxLength(100), this.validateAddress]],
      address_Street_Line2: ['', [Validators.maxLength(100), Validators.pattern(/^((?!\@).)*$/)]],
      address_City: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(/^((?!\@).)*$/)]],
      address_State: ['CA', [Validators.required, Validators.pattern(/^((?!\@).)*$/)]],
      address_Zip: ['', [Validators.required, Validators.maxLength(10), Validators.pattern(/^((?!\@).)*$/), ((c: AbstractControl) => {
        //open to all zip codes
        if (!this.acceptedZipCodes || this.acceptedZipCodes.length === 0 || 
          (this.acceptedZipCodes.length === 1 && this.acceptedZipCodes[0] === '')) {
          return null;
        }
        //check zip code
        if (this.acceptedZipCodes.length && this.acceptedZipCodes.includes(c.value)) {
          return null;
        }
        return { zipNotIncluded: true }
      })]],
      yearBuilt: ['', [
        Validators.required,
        Validators.min(Number.parseInt(this.program.yearBuiltBeginDate, 10)),
        Validators.max(Number.parseInt(this.program.yearBuiltEndDate, 10))
      ]],
      numberOfUnits: ['', []], 
  homeownerOccupied: [null],
  ownerAssociation: ['', []],
  squareFootage: ['', []],
      _Ebb_ProgramCycleId: [null, Validators.required]
    });

    if (this.program.typeCode === 700000004) {
      this.addressQuestion ="What is the property address for this building?"
      // If typeCode is 700000004, homeownerOccupied is not required and hidden
      this.dwellingInput.get('homeownerOccupied')?.clearValidators();

      this.dwellingInput.get('numberOfUnits')?.setValidators([
        Validators.required,
        Validators.min(Number.parseInt(this.program.numberOfUnitsMin, 10)),
        Validators.max(Number.parseInt(this.program.numberOfUnitsMax, 10))
      ]);
      this.dwellingInput.get('ownerAssociation')?.setValidators([
        Validators.required,
        Validators.maxLength(100),
      ]);
      this.dwellingInput.get('squareFootage')?.setValidators([
        Validators.required     
      ]);
    } else {
      // For other programs, homeownerOccupied is required
      this.dwellingInput.get('homeownerOccupied')?.setValidators(Validators.required);
      this.dwellingInput.get('numberOfUnits')?.clearValidators();
      this.dwellingInput.get('ownerAssociation')?.clearValidators();
      this.dwellingInput.get('squareFootage')?.clearValidators();
    }


    if (this.program && this.program.homeownerOccupied) {
      this.dwellingInput.get('homeownerOccupied').setValidators([Validators.requiredTrue]);
    }
    this.dwellingInput.get('homeownerOccupied')?.updateValueAndValidity();
    this.dwellingInput.get('numberOfUnits')?.updateValueAndValidity();
    this.dwellingInput.get('ownerAssociation')?.updateValueAndValidity();
    this.dwellingInput.get('squareFootage')?.updateValueAndValidity();
    this.enablePiEntry(true);

    this.dwelling$.subscribe((storedDwelling) => {
      this.dwellingInput.patchValue({ _Ebb_ProgramCycleId: storedDwelling._Ebb_ProgramCycleId});
      if(storedDwelling.address_Street){
        this.dwellingInput.get('address_Street').setValue(storedDwelling.address_Street);
        this._beforestreetnumber = this.startnumber(storedDwelling.address_Street)
        console.log("_beforestreetnumber"+this._beforestreetnumber.toString());
        this.dwellingInput.get('address_Street').markAsTouched();
        this.dwellingInput.get('address_Street_Line2').setValue(storedDwelling.address_Street_Line2);
        this.dwellingInput.get('address_Street_Line2').markAsTouched();
        this.dwellingInput.get('address_City').setValue(storedDwelling.address_City);
        this.dwellingInput.get('address_City').markAsTouched();
        this.dwellingInput.get('address_Zip').setValue(storedDwelling.address_Zip);
        this.dwellingInput.get('address_Zip').markAsTouched();
        this.dwellingInput.get('yearBuilt').setValue(storedDwelling.yearBuilt);
        this.dwellingInput.get('yearBuilt').markAsTouched();
        this.dwellingInput.get('address_State').setValue('CA');
        this.dwellingInput.get('address_State').markAsTouched();

        if (this.program.typeCode === 700000004) {
          this.dwellingInput.get('squareFootage').setValue(storedDwelling.squareFootage.toString());
          this.dwellingInput.get('squareFootage').markAsTouched();
          this.dwellingInput.get('numberOfUnits').setValue(storedDwelling.numberOfUnits.toString());
          this.dwellingInput.get('numberOfUnits').markAsTouched();
          this.dwellingInput.get('ownerAssociation').setValue(storedDwelling.ownerAssociation);
        this.dwellingInput.get('ownerAssociation').markAsTouched();
        }else{
        if(storedDwelling.homeownerOccupied == true){
          this.dwellingInput.get('homeownerOccupied').setValue(true);
          this.dwellingInput.get('homeownerOccupied').markAsTouched();
        }else if(storedDwelling.homeownerOccupied == false){
          this.dwellingInput.get('homeownerOccupied').setValue(false);
          this.dwellingInput.get('homeownerOccupied').markAsTouched();
        }
      }
      }
    });

    this.dwellingInput.valueChanges.subscribe(x => {
      this.isFormInvalid.emit(this.dwellingInput.invalid);
    });
  }
  private loadHelpText(): void {
    const programLocalStore = localStorage.getItem('ebbprogram');
      if (window['program']) {
        this.programTypeCodeOptionSet = window['program'];
      } else if (programLocalStore) {
        this.programTypeCodeOptionSet = programLocalStore;
      } else {
        this.programTypeCodeOptionSet = 'FEMA|EBB'; //default to EBB programs
      }
      const settings = this.appLoadService.readEnvironSettings();
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = JSON.parse(JSON.stringify(data));
          let indexHelpIndex = this.listHelp.findIndex(i => i.name.toLowerCase() === 'ebbyearbuilt');
          if(settings.ProgramIsCeaBb){
            indexHelpIndex = this.listHelp.findIndex(i => i.name.toLowerCase() === 'ceabbyearbuilt');
          }
          if(settings.ProgramIsEss){
            indexHelpIndex = this.listHelp.findIndex(i => i.name.toLowerCase() === 'essyearbuilt');
          }
          if(settings.ProgramIsEmr){
            indexHelpIndex = this.listHelp.findIndex(i => i.name.toLowerCase() === 'emryearbuilt');
          }


          this.yearBuildContent = this.formatHelptext(this.listHelp[indexHelpIndex].answer);

          indexHelpIndex = this.listHelp.findIndex(i => i.name.toLowerCase() === 'emrnumberofunits');
          this.numberOfUnitsContent= this.formatHelptext(this.listHelp[indexHelpIndex].answer);
          indexHelpIndex = this.listHelp.findIndex(i => i.name.toLowerCase() === 'emrownerassociation');
          this.ownerAssociationContent= this.formatHelptext(this.listHelp[indexHelpIndex].answer);
          indexHelpIndex = this.listHelp.findIndex(i => i.name.toLowerCase() === 'emrsquarefootage');
          this.squareFootageContent= this.formatHelptext(this.listHelp[indexHelpIndex].answer);
          
        },
        error => console.log(error)
      );
  }
public validateAddress(c: FormControl) {
  
    let AddressRegex = /^(\d{1,}[a-zA-Z0-9-/.#]?) [a-zA-Z0-9-/.\s#]+$/; 
    let PoRegex = /\b(p|P)(ost|ostal)?([ \.]*(O|o|0)(ffice)?)?([ \.]*(b|B)(o|O|0)(x|X))\b/;  
  
    return (AddressRegex.test(c.value) && !PoRegex.test(c.value)) ? null : {
      validateAddress: {
        valid: false
      }
    };
  }

public startnumber(streetaddress:string){

  var startingNumber = ( streetaddress
  .match(/\d+\.\d+|\d+\b|\d+(?=\w)/g) || [] )
  .map(function (v) {return +v;}).shift();

  return startingNumber;
}
public constructYearBuiltArray(program: IProgramCycle): void {
  const beginDate = program.yearBuiltBeginDate ? Number.parseInt(program.yearBuiltBeginDate, 10) : 1800;
  const endDate = program.yearBuiltEndDate ? Number.parseInt(program.yearBuiltEndDate, 10) : 1980;

  for (let i = endDate; i >= beginDate; i--) {
    this.yearBuiltArray.push(i.toString());
  }
}


  public constructNumberOfUnitsArray(program: IProgramCycle): void {
    const min = program.numberOfUnitsMin ? Number.parseInt(program.numberOfUnitsMin, 10) : 5;
    const max = program.numberOfUnitsMax ? Number.parseInt(program.numberOfUnitsMax, 10) : 10;
  
    for (let i = min; i <= max; i++) {
      this.numberOfUnitsArray.push(i.toString());
    }
  }
  public onFocus(event: Event): void {
    window['angularGooglePlaceDetailRef'] = { component: this, zone: this.zone };
  }

    public openDropdown(suggestions: any[]): void {
        let list = [];
        for (let suggestion of suggestions) {
            const placePrediction = suggestion.placePrediction;
            list.push(placePrediction);
        }
        this.listResults = list;
    }

  public async getPlaceDetails(result: any) {
        if (this.isServiceAvailable()) {
            const place = new google.maps.places["Place"]({
                id: result.placeId
            });

            await place.fetchFields({
                fields: ["displayName", "formattedAddress", "postalAddress", "location"]
            });

            this.fillInAddress(place.postalAddress, null);

        }
    }

    //way to handle google maps library loading async
    //quick way for now to avoid typescript implementation and reference errors
    //https://developers.google.com/maps/documentation/javascript/overview#js_api_loader_package
    public isServiceAvailable() {
        return true;
    }

  public async fillInAddress(place: any, status: any): Promise<void> {
   
      const address1 = place.addressLines[0];
      
  let address = address1 ?? '';
  let address2 = '';
  let city = place.locality;
let zip = place.postalCode ?? '';

// Keep only the 5-digit part
if (zip.includes('-')) {
  zip = zip.split('-')[0];
}
  let state = place.administrativeArea.substring(0,2).toUpperCase();
  // Patch your existing reactive form (same control names you used before)
  this.zone.run(() => {
    this.dwellingInput.patchValue({
      address_Street: address.trim(),
      address_Street_Line2: address2.trim(),
      address_City: city.trim(),
      address_Zip: zip.trim()
    }, { emitEvent: false });
  // Keep your touched/dirty behavior
    this.dwellingInput.get('address_Street')?.markAsTouched();
    this.dwellingInput.get('address_Street_Line2')?.markAsTouched();
    this.dwellingInput.get('address_City')?.markAsTouched();
    this.dwellingInput.get('address_Zip')?.markAsTouched();
    this.dwellingInput.get('address_Street')?.markAsDirty();
    this.dwellingInput.get('address_City')?.markAsDirty();
    this.dwellingInput.get('address_Zip')?.markAsDirty();
  });
  }
  public enablePiEntry(enable: boolean): void {
    if (enable && this._policies && this.dwellingInput) {
      this.dwellingInput.addControl('pi', new FormControl('', Validators.required));
    } else if(this.dwellingInput) {
      this.dwellingInput.removeControl('pi');
    }
  }

  public onKey(e: any): void {
    const key = e.keyCode;
    let $selected = this.listResults.findIndex(element => element.selected === true);

    if (key === 40) {
      if (!this.listResults.length || this.listResults.length <= $selected + 1) {
        $selected = 0;
      } else {
        $selected += 1;
      }
      for (let i = 0; i <this.listResults.length; i++) {
        if (i === $selected) {
          this.listResults[i].selected = true;
          continue;
        }
        this.listResults[i].selected = false;
      }
    } else if (key === 38) {
      if (!this.listResults.length || $selected <= 0) {
        $selected = this.listResults.length + 1;
      } else {
        $selected -= 1;
      }

      for (let i = 0; i < this.listResults.length; i++) {
        if (i === $selected) {
          this.listResults[i].selected = true;
          continue;
        }
        this.listResults[i].selected = false;
      }
    } else if (key === 13) {
      if (this.listResults.length > 0) {
        console.log(this.listResults[$selected]);
        this.getPlaceDetails(this.listResults[$selected]);
        this.listResults = [];
      }
       e.preventDefault();
    }
  }

  public toNextSection(): void {
    const dwelling: IDwellingReturned = this.dwellingInput.getRawValue();
   this._afterstreetnumber = this.startnumber(dwelling.address_Street);
   console.log("_afterstreetnumber"+this._afterstreetnumber.toString());
   let addresschange = false;
   if(this._beforestreetnumber !=0 && this._beforestreetnumber != this._afterstreetnumber){
    addresschange = true;
 
    

    console.log("clear");
   }
    this.isFormInvalid.emit(false);
    this._dwellingNextInProcess = true;
    if (this.dwelling$) {
      this.dwelling$.subscribe((storedDwelling) => {
        dwelling.id = storedDwelling.id;
        
          let name = "addresschange" + storedDwelling.id;
          this.setCookie(name, addresschange==true?"true":"false", 1);
        
       
        this.emitDwelling.emit(dwelling);
      }).unsubscribe();
    } else {
      this.emitDwelling.emit(dwelling);
    }
    this.dwellingInput.markAsPristine();
  }

  public continueEnabled(): boolean {
    if (this.dwellingInput.valid && !this._dwellingNextInProcess) {
      return true;
    }
    return false;
  }

  private setCookie(name, value, days) {
    let  expires = '';
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  showMoreYearBuild(): void {
    this.drawerContent =this.yearBuildContent;
    this.drawerOpen = true;
  }
  showMoreNubmerOfUnits(): void {
    this.drawerContent =this.numberOfUnitsContent;
    this.drawerOpen = true; 
  }
  showMoreOwnerAssociation(): void {
    this.drawerContent =this.ownerAssociationContent;
    this.drawerOpen = true; 
  }
  showMoreSquareFootage(): void {
    this.drawerContent =this.squareFootageContent;
    this.drawerOpen = true; 
  }
  toggleDrawer(): void {
    this.drawerOpen = !this.drawerOpen;
  }
  public formatHelptext(content: string): SafeHtml {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;

    resultHtml = this.youTubeLinks(resultHtml);
    resultHtml = this.vemioLinks(resultHtml);
    resultHtml = resultHtml.replace(/(\r\n|\n|\r)/gm, '<br/>');
    return this.sanitizer.bypassSecurityTrustHtml(resultHtml);
  }

  public youTubeLinks(content: string): string {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;

    const fullreg = /(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const match = resultHtml.match(fullreg);
    if (match && match.length > 0) {
      for (let i = 0; i < match.length; i++) {
        const matchParts = match[i].split(regex);
        resultHtml = resultHtml.replace(
          match[i],
          this.createYoutubeEmbed(matchParts[1])
        );
      }
    }
    return resultHtml;
  }

  public vemioLinks(content: string): string {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;

    const fullreg = /(https?:\/\/)?(www\.)?(vimeo.com\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo.com\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const match = resultHtml.match(fullreg);
    if (match && match.length > 0) {
      for (let i = 0; i < match.length; i++) {
        const matchParts = match[i].split(regex);
        resultHtml = resultHtml.replace(
          match[i],
          this.createVimeoEmbed(matchParts[1])
        );
      }
    }
    return resultHtml;
  }

  public createYoutubeEmbed(key) {
    return (
      '<div class="aspect-ratio-video"><iframe src="' +
      'https://www.youtube.com/embed/' +
      key +
      '" frameborder="0" allowfullscreen></iframe></div>'
    );
  }

  public createVimeoEmbed(key) {
    return (
      '<div class="aspect-ratio-video"><iframe src="' +
      'https://player.vimeo.com/video/' +
      key +
      '" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>'
    );
  }
}
